import React, { Component } from 'react'
import {
  Modal,
  Button,
  Progress,
  Spin,
} from 'antd'
import dayjs from "dayjs"

// import './common.css'
import { downloadMulti } from '@/utils/file';
import { CreateImportExportTaskParams, GetImportExportTaskResponse, serviceCreateImportExportTask, serviceGetImportExportTask } from './services/task';
import { ReloadOutlined } from '@ant-design/icons'; 
import { isError } from '@/component/common/error'
import styled from 'styled-components'

export const progressPercent = (text = '0/100') => {
  if (typeof text !== 'string') return null

  const [number, total] = text.split('/');

  return Math.floor(Number(number) / Number(total) * 100)
}


const ExportSpinView = styled.div`
  .exportInfo-info-box>div {
    line-height: 30px;
  }
  .exportInfo-progress-box .text-center {
    line-height: 40px;
  }
  .exportInfo-info-box {
    margin: 24px auto 0;
    color: rgba(0, 0, 0, .85);
  }
  .exportInfo-progress-box {
    margin: 0 auto;
    border-bottom: 1px solid #E8E8E8;
  }
  .exportInfo-progress .ant-progress-bg {
    height: 18px !important;
  }
`

function parseURL(url: string) {
  // var a = document.createElement('a');
  // a.href = url;
 let file =  url.split('?')[0].split('/')[url.split('?')[0].split('/').length - 1]
  return {
    // source: url,
    // protocol: a.protocol.replace(':',''),
    // host: a.hostname,
    // port: a.port,
    // query: a.search,
    // params: (function(){
    //     var ret:any = {},
    //     seg = a.search.replace(/^\?/,'').split('&'),
    //     len = seg.length, i = 0, s;
    //     for (;i<len;i++) {
    //         if (!seg[i]) { continue; }
    //         s = seg[i].split('=');
    //         ret[s[0]] = s[1];
    //     }
    //     return ret;
    // })(),
    // file: (a.pathname.match(/\/([^\/?#]+)$/i) || [,''])[1],
    file: file,
    // hash: a.hash.replace('#',''),
    // path: a.pathname.replace(/^([^\/])/,'/$1'),
    // relative: (a.href.match(/tps?:\/\/[^\/]+(.+)/) || [,''])[1],
    // segments: a.pathname.replace(/^\//,'').split('/')
  };
}
const downloadAll = (urlList?: string[]) => {
  urlList = urlList || []
  downloadMulti(urlList)
}
const footer = (data: {status?:number,url?:string[]}, onClose: ()=>void) => (
  <div>
    {
      data.status === 2 && (
        <Button style={{ marginRight: '8px' }} onClick={() => { downloadAll(data.url) }} download>全部下载</Button>
      )
    }
    <Button onClick={onClose} type='primary'>关闭</Button>
  </div>
)

interface ExportProps {
  onClose(): void
  createTaskData: CreateImportExportTaskParams
  // modalData:{
  //   url:any[],
  //   status:any,
  //   visible:boolean
  //   progress:any,
  //   created_at:any
  // }
}
interface ExportState {
  isLoading: false,
  //   rect: true,
  //   left: 0,
  //   top: 0,
  exportModalData: {
    data: Partial<GetImportExportTaskResponse>,
    time: string,
    loading: boolean,
    error: {}
  },
  visible: boolean,
  data: {}
}


export class Export extends Component<ExportProps, ExportState> {
  state: ExportState = {
    isLoading: false,
    //   rect: true,
    //   left: 0,
    //   top: 0,
    exportModalData: {
      data: {
        status: 0
      },
      time: '',
      loading: false,
      error: {}
    },
    visible: true,
    data: {}
  }
  onClose = () => {
    this.props.onClose()
  }
  componentDidMount() {
    this.geTaskData()

  }
  geTaskData = async () => {
    let res = await serviceCreateImportExportTask(this.props.createTaskData)
    if (isError(res)) {
      return
    }
    this.loopTask(res.data.taskId)
  }
  timeId?: NodeJS.Timeout
  loopTask = async (taskId: string) => {
    let res = await serviceGetImportExportTask(taskId)
    if (isError(res)) {
      return
    }
    let time = dayjs().format('YYYY-MM-DD HH:mm:ss')
    let reformData = { ...this.state.exportModalData.data, ...res.data }
    this.setState({ exportModalData: { data: reformData, time, loading: true, error: {} } })
    if (reformData.status !== 4 && reformData.status !== 5) {
      this.timeId = setTimeout(() => {
        this.loopTask(taskId)
      }, 5000)
    }
  }
  componentWillUnmount() {
    clearTimeout(this.timeId)
  }
  renderScreen() {
    const data = this.state.exportModalData.data
    let files = data.files || []
    let progress = progressPercent(data.progress)
    return (
      <Spin spinning={false} tip={'任务创建中'}>
        <ExportSpinView>

        <div className={'exportInfo-progress-box'}>
          <Progress className='exportInfo-progress' percent={progress || 0} showInfo={false} status='success' />
          {
            data.progress ? (
              <div className='text-center' style={{textAlign:'center'}}>
                当前进度：{progress}%，已导出行：{data.success}
                {/* 当前进度：100%，已导出行：{data.progress.split('/')[0]} */}
              </div>
            ) :
              <div className='text-center'>
                当前进度：0，已导出行：0
              </div>
          }

        </div>
        <div className={'exportInfo-info-box'}>
          <div className='item'>当前状态：{data.statusText}</div>
          <div className='item'>已导出行：{data.success}</div>
          <div className='item'>导出时间：{data.createdAt}</div>
          {files.length > 0 &&
            <div style={{ display: 'flex' }}>
              <div style={{ paddingRight: '11px',flexShrink:0 }}>生成文件: </div>
              <div style={{ maxHeight: '256px', overflowY: 'auto' }}>
                {
                  files.map(item => <div>
                    { parseURL(item).file }
                    <a className="filter-expand stop-bubble" onClick={() => { 
                      window.open(item)
                     }} style={{ marginLeft: '10px' }}>下载</a>
                  </div>
                  )
                }
              </div>
            </div>
          }
          <p style={{ fontSize: 10, color: '#999', marginTop: 15 }}>请在右上角 <ReloadOutlined  /> 查看导出历史</p>
        </div>
        </ExportSpinView>
        {/* <div className={'exportInfo-info-box'}>
                    <div>当前状态：已完成</div>
                    <div>已导出行：{data.progress}</div>
                    <div>导出时间：{data.created_at || data.createdAt}</div>
                    <div style={{ display: 'flex' }}>
                        <div style={{paddingRight:'11px'}}>生成文件: </div>
                        <div style={{maxHeight:'256px',overflowY:'auto'}}>
                            {
                               (data.files ||[]).map(item=><div> {decodeURIComponent(parseURL(decodeURIComponent(item)).file)} <a className="filter-expand stop-bubble" onClick={() => {window.open(item) }} style={{marginLeft:'10px'}}>下载</a></div>)
                            }
                        </div>
                    </div>
                </div> */}
      </Spin>
    )
  }

  render() {
    const { exportModalData } = this.state
    const { visible } = this.state
    const data = exportModalData.data

    return (
      <div>
        <Modal
          title='导出进度'
          open={visible}
          footer={footer({status: data.status, url: data.files}, this.props.onClose)}
          className='exportInfo-modal'
          centered
          destroyOnClose
          closable={false}
          maskClosable={false}
          zIndex={9999}
          width={530}
        >
          {this.renderScreen()}
        </Modal>
      </div>
    )
  }
}